<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card bg-pattern">
          <div class="card-body p-4">
            <div class="text-center w-75 m-auto">
              <a href="/">
                <span>
                  <img v-if="!isHeaven" src="@assets/images/logo.png" height="44" />
                  <img v-else src="@assets/img/heaven/logo.svg" height="44" />
                </span>
              </a>
              <p class="text-muted mb-4 mt-3">
                Insira seu e-mail e senha para acessar o painel administrativo.
              </p>
            </div>

            <b-alert v-model="isAuthError" variant="danger" dismissible>
              {{ authError }}
            </b-alert>

            <b-form @submit.prevent="tryToLogIn">
              <b-form-group id="input-group-1" label="E-mail" label-for="input-1">
                <b-form-input
                    id="input-1"
                    v-model="username"
                    v-validate="'required|email'"
                    type="text"
                    class="input-login"
                    name="username"
                    placeholder="exemplo@exemplo.com"
                    :disabled="submit"
                ></b-form-input>
                <b-form-invalid-feedback :state="submit ? !errors.has('username') : null">
                  Preencha o usuário corretamente.
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group id="input-group-2" label="Senha" label-for="input-2">
                <b-form-input
                    id="input-2"
                    v-model="password"
                    v-validate="'required'"
                    class="input-login"
                    name="password"
                    type="password"
                    placeholder="************"
                    :disabled="submit"
                ></b-form-input>
                <b-form-invalid-feedback :state="submit ? !errors.has('password') : null">
                  Preencha a senha.
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group id="button-group" class="mt-4">
                <b-button
                    type="submit"
                    variant="primary"
                    class="btn-block"
                    :disabled="!username || !password || submit"
                >
                  <b-spinner v-if="submit" label="Loading..." small></b-spinner>
                  <div v-if="!submit">Entrar</div>
                </b-button>
              </b-form-group>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@layouts/auth'
import { authMethods } from '@store/helpers'
import appConfig from '@src/app.config'

export default {
  page: {
    title: 'Log in',
    meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
  },
  components: { Layout },
  data() {
    return {
      submit: false,
      username: '',
      password: '',
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
    }
  },
  computed: {
    isHeaven() {
      return this.$store.getters["getIsHeaven"]
    },
  },
  methods: {
    ...authMethods,
    tryToLogIn() {
      this.submit = true;

      this.isAuthError = false;
      this.authError = null;

      this.$validator.validateAll().then(async (result) => {
        this.tryingToLogIn = true;

        if (result) {
          const data = {
            username: this.username,
            password: this.password,
          };

          if (process.env.VUE_APP_FINGERPRINT_ENABLED === 'true') {
            await this.$store.dispatch('fetchFingerprint');
          }

          this.$store
              .dispatch('loginRequest', data)
              .then(() => {
                this.isAuthError = false;
                this.authError = null;
              })
              .catch((err) => {
                this.isAuthError = true;

                if (err.response && err.response.data) {
                  this.authError = err.response.data.message ||
                      err.response.data.error ||
                      'Erro ao realizar login.';
                } else if (err.message) {
                  this.authError = err.message;
                } else {
                  this.authError = 'Erro ao realizar login.';
                }
              })
              .finally(() => {
                this.submit = false;
              });
        } else {
          this.submit = false;
        }
      });
    },
  }
};
</script>

<style scoped>
.input-login:disabled {
  background: #f7f7f7;
}
</style>
